import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from "../../store/actions";
import axios from "../../utils/axios";
import Swal from 'sweetalert2';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Row, Col, Card, CardBody, CardImg, Badge, CardTitle, Spinner, InputGroup, InputGroupText } from 'reactstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import moment from 'moment';
import debounce from 'lodash.debounce';
import { FiCircle, FiCheckCircle, FiEdit, FiTrash2, FiEye, FiMoreVertical, FiUpload, FiPlus, FiX } from 'react-icons/fi';
import { FaDotCircle, FaArrowRight, FaArrowLeft } from "react-icons/fa";
const EventsManagement = (props) => {
    const [step, setStep] = useState(1);
    document.title = "Session Management | Equity Circle - Admin Dashboard";
    const breadcrumbItems = [
        { title: "Sessions Management", link: "#" },
        { title: "All Sessions", link: "#" },
    ];

    useEffect(() => {
        props.setBreadcrumbItems('Session Management', breadcrumbItems);
    }, []);

    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ticketLoading, setTicketLoading] = useState(false);
    const [tickets, setTickets] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [ticketModal, setTicketModal] = useState(false);
    const [types, setTypes] = useState([]);
    const [organizers, setOrganizers] = useState([]);
    const [organizerSearch, setOrganizerSearch] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [eventStatus, setEventStatus] = useState([]);
    const [categories, setCategories] = useState([]);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [newCategory, setNewCategory] = useState({ name: '', description: '' });
    const [isAddingCategory, setIsAddingCategory] = useState(false);
    const [showNewOrganizerModal, setShowNewOrganizerModal] = useState(false);
    const [newOrganizer, setNewOrganizer] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [isCreatingOrganizer, setIsCreatingOrganizer] = useState(false);
    const [eventFilter, setEventFilter] = useState('allEvents')

    const [imagePreview, setImagePreview] = useState(null);
    const [imageFile, setImageFile] = useState(null);

    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         setImageFile(file);
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setImagePreview(reader.result);
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file && file.type.startsWith('image/')) {
            setImageFile(file);

            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            // Optionally clear previous preview/file if not a valid image
            setImageFile(null);
            setImagePreview(null);
            alert("Please select a valid image file.");
        }
    };

    const [modal, setModal] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);

    const [eventData, setEventData] = useState({
        title: '',
        description: '',
        subtitle: '',
        event_date: '',
        start_time: '',
        end_time: '',
        status_id: '',
        organizer_id: '',
        type_id: '',
        category_id: '',
        price: '',
        standard_price: '',
        premium_price: '',
        followers: '',
        location: '',
        lat: '',
        long: '',
        mode: '',
        country: '',
        promoted: 0
    });

    const createEvent = () => {
        setEditingEvent(null);
        setModal(true);
        setCurrentStep(1);
        setEventData({
            title: '',
            description: '',
            subtitle: '',
            event_date: '',
            start_time: '',
            end_time: '',
            status_id: '',
            organizer_id: '',
            type_id: '',
            category_id: '',
            price: '',
            standard_price: '',
            premium_price: '',
            followers: '',
            location: '',
            lat: '',
            long: '',
            mode: '',
            country: '',
            promoted: 0
        });
        setImagePreview(null);
        setImageFile(null);
    };

    // const handleInputChange = (e) => {
    //     const { name, value, type, checked } = e.target;
    //     setEventData(prev => ({
    //         ...prev,
    //         [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
    //     }));
    // };
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setEventData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? Number(checked) : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("handleSubmit called on step:", currentStep);
        // 🚫 DO NOT DO THIS:
        // if (currentStep !== 4) { nextStep(); return; }

        setLoading(true);

        try {
            const formData = new FormData();
            Object.keys(eventData).forEach(key => {
                formData.append(key, eventData[key]);
            });

            if (imageFile) {
                formData.append('media', imageFile);
            }

            let response;
            if (editingEvent) {
                formData.append('_method', 'PUT');
                response = await axios.post(`/api/events/${editingEvent}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                response = await axios.post('/api/events', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            Swal.fire(
                'Success!',
                `Event ${editingEvent ? 'updated' : 'created'} successfully!`,
                'success'
            );

            setModal(false);
            fetchEvents();
            setImagePreview(null);
            setImageFile(null);
            setEditingEvent(null);
        } catch (error) {
            Swal.fire(
                'Error!',
                error.response?.data?.message || `Failed to ${editingEvent ? 'update' : 'create'} event`,
                'error'
            );
        } finally {
            setLoading(false);
        }
    };


    const nextStep = (e) => {
        setCurrentStep(prev => {
            e.preventDefault();
            const next = prev + 1;
            console.log("Next clicked. Current step:", next);
            return next;
        });
    };

    const prevStep = () => {
        console.log("Previous clicked. Current step:", currentStep);
        setCurrentStep(currentStep - 1);
    };

    const renderStepForm = () => {
        switch (currentStep) {
            case 1:
                return (

                    <div>
                        <FormGroup>
                            <Label>Event Image *</Label>
                            <Input
                                type="file"
                                name="media"
                                onChange={handleImageChange}
                                accept="image/*"
                                required={!imagePreview}
                            />
                            {imagePreview && (
                                <div className="mt-2" style={{aspectRatio:'16/9',objectFit:'cover',overflow:'hidden',width:'300px'}}>
                                    <img
                                        src={imagePreview}
                                        alt="Preview"
                                        style={{ maxWidth: '100%', maxHeight: '200px' }}
                                        className="img-thumbnail"
                                    />
                                </div>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label>Session Title *</Label>
                            <Input type="text" name="title" value={eventData.title} onChange={handleInputChange} required />
                        </FormGroup>
                        <FormGroup>
                            <Label>Subtitle</Label>
                            <Input type="text" name="subtitle" value={eventData.subtitle} onChange={handleInputChange} />
                        </FormGroup>
                        <FormGroup>
                            <Label>Description *</Label>
                            <Input type="textarea" name="description" value={eventData.description} onChange={handleInputChange} required />
                        </FormGroup>
                    </div>
                );
            case 2:
                return (
                    <div>
                        <FormGroup>
                            <Label>Session Date *</Label>
                            <Input type="date" name="event_date" value={eventData.event_date} onChange={handleInputChange} required />
                        </FormGroup>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Start Time *</Label>
                                    <Input type="time" name="start_time" value={eventData.start_time} onChange={handleInputChange} required />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>End Time *</Label>
                                    <Input type="time" name="end_time" value={eventData.end_time} onChange={handleInputChange} required />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                );
            case 3:
                return (
                    <div>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <Label className="mb-0">Session category *</Label>
                                        <Button
                                            type="button"
                                            color="link"
                                            className="p-0 text-decoration-none"
                                            onClick={() => setShowCategoryModal(true)}
                                        >
                                            <i className="bx bx-plus"></i> Add New
                                        </Button>
                                    </div>
                                    <InputGroup>
                                        <Input
                                            type="select"
                                            name="category_id"
                                            value={eventData.category_id}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map(category => (
                                                <option key={category.id} value={category.id}>{category.name}</option>
                                            ))}
                                        </Input>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Session Mode *</Label>
                                    <Input type="select" name="mode" value={eventData.mode} onChange={handleInputChange} required>
                                        <option value="">Select Mode</option>
                                        <option value="online">Online</option>
                                        <option value="physical">Physical</option>
                                        <option value="hybrid">Hybrid</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Status *</Label>
                                    <Input type="select" name="status_id" value={eventData.status_id} onChange={handleInputChange} required>
                                        <option value="">Select Status</option>
                                        {eventStatus.map(status => (
                                            <option key={status.id} value={status.id}>{status.name}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <Label className="mb-0">Organizer *</Label>
                                        <Button
                                            type="button"
                                            color="link"
                                            className="p-0 text-decoration-none"
                                            onClick={() => setShowNewOrganizerModal(true)}
                                        >
                                            <i className="bx bx-plus"></i> Add New
                                        </Button>
                                    </div>
                                    <Select
                                        name="organizer_id"
                                        value={eventData.organizer_id ? {
                                            value: eventData.organizer_id,
                                            label: organizers.find(org => org.id === eventData.organizer_id)?.name ||
                                                organizers.find(org => org.id === eventData.organizer_id)?.email
                                        } : null}
                                        onChange={(selectedOption) => {
                                            setEventData(prev => ({
                                                ...prev,
                                                organizer_id: selectedOption ? selectedOption.value : ''
                                            }));
                                        }}
                                        onInputChange={(inputValue, { action }) => {
                                            if (action === 'input-change') {
                                                setOrganizerSearch(inputValue);
                                            }
                                        }}
                                        options={organizers.map(org => ({
                                            value: org.id,
                                            label: org.name || org.email
                                        }))}
                                        isClearable
                                        placeholder="Search and select organizer..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        isLoading={isLoading}
                                        loadingMessage={() => "Loading..."}
                                        noOptionsMessage={() => "No organizers found"}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <FormGroup check>
                                <Input
                                    type="checkbox"
                                    name="promoted"
                                    checked={eventData.promoted}
                                    onChange={handleInputChange}
                                />
                                <Label check>Promote this Session</Label>
                            </FormGroup>
                        </Row>
                    </div>
                );
            case 4:
                return (
                    <div>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Location *</Label>
                                    <Input type="text" name="location" value={eventData.location} onChange={handleInputChange} required />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Country *</Label>
                                    <Input type="text" name="country" value={eventData.country} onChange={handleInputChange} required />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Latitude *</Label>
                                    <Input type="text" name="lat" value={eventData.lat} onChange={handleInputChange} required />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Longitude *</Label>
                                    <Input type="text" name="long" value={eventData.long} onChange={handleInputChange} required />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Regular Price</Label>
                                    <Input type="number" name="price" value={eventData.price} onChange={handleInputChange} />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Standard Price</Label>
                                    <Input type="number" name="standard_price" value={eventData.standard_price} onChange={handleInputChange} />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Premium Price</Label>
                                    <Input type="number" name="premium_price" value={eventData.premium_price} onChange={handleInputChange} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <FormGroup>
                            <Label>Expected Followers</Label>
                            <Input type="number" name="followers" value={eventData.followers} onChange={handleInputChange} />
                        </FormGroup>
                    </div>
                );
            default:
                return null;
        }
    };

    const fetchEvents = () => {
        axios.get('/api/events-crm')
            .then(response => {
                setEvents(response.data);
                setLoading(false);
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'Failed to fetch Session',
                });
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchEvents();
        axios.get('/api/event-types')
            .then(response => {
                setTypes(response.data);
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'Failed to fetch Session types',
                });
            });
        fetchCategories();
        // axios.get('/api/categories')
        //     .then(response => {
        //         setCategories(response.data);
        //     })
        //     .catch(error => {
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Error',
        //             text: error.response?.data?.message || 'Failed to fetch event categories',
        //         });
        //     });
        // axios.get(`/api/users/search?query=''`)
        //     .then(response => {
        //         setOrganizers(response.data);
        //     })
        //     .catch(error => {
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Error',
        //             text: error.response?.data?.message || 'Failed to fetch organizers',
        //         });
        //     });
        fetchUsers();
        axios.get('/api/event-status')
            .then(response => {
                setEventStatus(response.data);
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'Failed to fetch Session status',
                });
            });
    }, []);


    const fetchUsers = async (query = '') => {
        setIsLoading(true);
        try {
            const response = await axios.get(`/api/users/search?query=${query}`);
            setOrganizers(response.data);
            return response.data;
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to fetch organizers',
            });
            return [];
        } finally {
            setIsLoading(false);
        }
    };

    const handleCreateOrganizer = async () => {
        if (newOrganizer.password !== newOrganizer.confirmPassword) {
            Swal.fire('Error', 'Passwords do not match', 'error');
            return;
        }

        setIsCreatingOrganizer(true);
        try {
            const response = await axios.post('/api/register', {
                name: newOrganizer.name,
                email: newOrganizer.email,
                password: newOrganizer.password,
                password_confirmation: newOrganizer.confirmPassword,
                role: 'organizer'
            });

            // Refresh the organizers list
            // fetchUsers();

            // Set the newly created organizer as selected
            const newOrganizerData = response.data.user || response.data;
            setOrganizers(prev => [...prev, newOrganizerData]);
            setEventData(prev => ({
                ...prev,
                organizer_id: newOrganizerData.id
            }));

            Swal.fire('Success', 'Organizer created successfully', 'success');
            setShowNewOrganizerModal(false);
            setNewOrganizer({
                name: '',
                email: '',
                password: '',
                confirmPassword: ''
            });
        } catch (error) {
            console.error('Error creating organizer:', error);
            Swal.fire(
                'Error',
                error.response?.data?.message || 'Failed to create organizer',
                'error'
            );
        } finally {
            setIsCreatingOrganizer(false);
        }
    };

    const debouncedSearch = useCallback(
        debounce((query) => {
            fetchUsers(query);
        }, 300),
        []
    );

    useEffect(() => {
        debouncedSearch(organizerSearch);
        return () => debouncedSearch.cancel();
    }, [organizerSearch, debouncedSearch]);

    const onDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`/api/events/${id}`)
                    .then(response => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Session deleted successfully',
                        });
                        setEvents(events.filter(event => event.id !== id));
                    })
                    .catch(error => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: error.response?.data?.message || 'Failed to delete Session',
                        });
                    });
            }
        });
    };

    const [editingEvent, setEditingEvent] = useState(null);

    const onEdit = (event) => {
        setEditingEvent(event.id);
        setModal(true);
        setCurrentStep(1);

        setEventData({
            title: event.title || '',
            description: event.description || '',
            subtitle: event.subtitle || '',
            event_date: event.event_date ? moment(event.event_date).format('YYYY-MM-DD') : '',
            start_time: event.start_time ? moment(event.start_time, ['h:mm A', 'HH:mm']).format('HH:mm') : '',
            end_time: event.end_time ? moment(event.end_time, ['h:mm A', 'HH:mm']).format('HH:mm') : '',
            status_id: event.status_id || '',
            organizer_id: event.organizer_id || '',
            type_id: event.type_id || '',
            category_id: event.category_id || '',
            price: event.price || '',
            standard_price: event.standard_price || '',
            premium_price: event.premium_price || '',
            followers: event.followers || '',
            location: event.location.location || '',
            lat: event.location.lat || '',
            long: event.location.long || '',
            mode: event.mode || '',
            country: event.location.country || '',
            promoted: event.promoted ? 1 : 0
        });

        if (event.media_url) {
            setImagePreview(event.media_url);
        } else {
            setImagePreview(null);
        }
        setImageFile(null);
    };

    const now = moment();
    const todayStart = moment().startOf('day');
    const todayEnd = moment().endOf('day');

    const upcomingEvents = events.filter(event => {
        const eventDate = moment(event.event_date);
        const startTime = moment(event.start_time);
        return eventDate.isAfter(now);
    });

    const todaysEvents = events.filter(event => {
        const eventDate = moment(event.event_date);
        const startTime = moment(event.start_time);
        const endTime = moment(event.end_time);
        return eventDate.isSame(now, 'day');
    });

    const pastEvents = events.filter(event => {
        const eventDate = moment(event.event_date);
        const endTime = moment(event.end_time);
        return eventDate.isBefore(now, 'day');
    });

    const getEventBadgeColor = (event) => {
        const eventDate = moment(event.event_date);
        const startTime = moment(event.start_time);
        const endTime = moment(event.end_time);

        if (eventDate.isSame(now, 'day') && startTime.isBefore(now) && endTime.isAfter(now)) {
            return 'warning'; // Ongoing event
        } else if (eventDate.isAfter(now) || (eventDate.isSame(now, 'day') && startTime.isAfter(now))) {
            return 'success'; // Upcoming event
        } else {
            return 'secondary'; // Past event
        }
    };

    const handleViewTickets = async (event) => {
        setSelectedEvent(event);
        setTicketLoading(true);
        setTicketModal(true);

        try {
            const response = await axios.get(`/api/event-tickets?event_id=${event.id}`);
            setTickets(response.data.tickets || []);
        } catch (error) {
            console.error('Error fetching tickets:', error);
            toast.error(error.response?.data?.message || 'Failed to fetch tickets');
        } finally {
            setTicketLoading(false);
        }
    };

    const renderEventCard = (event) => (
        <Col sm={12} md={6} lg={4} xl={3}>
            <Card
                key={event.id}
                className="mb-0 border-0 custom-font-family h-100"
                style={{
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    boxShadow: '0 0 6px 0 rgb(158, 158, 158)'
                }}
                onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 0 6px 0 rgb(137, 136, 136)';
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 0 6px 0 rgb(158, 158, 158)';
                }}
            >
                {event.media && (
                    <div className="position-relative">
                        <CardImg
                            top
                            src={`${axios.defaults.baseURL}/${event.media}`}
                            alt={event.title}
                            style={{ height: '180px', objectFit: 'cover' }}
                        />
                        <Badge
                            color={getEventBadgeColor(event)}
                            className="position-absolute custom-transparent-batch"
                            style={{ top: '10px', left: '10px', }}
                        >
                            {getEventBadgeColor(event) === 'warning' ? 'Ongoing' :
                                getEventBadgeColor(event) === 'success' ? 'Upcoming' : 'Past'}
                        </Badge>
                        <Badge color="info" className="position-absolute custom-white-batch"
                            style={{ top: '10px', right: '10px' }}>{event.category?.name}</Badge>


                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                background: 'rgba(0, 0, 0, 0.3)',
                                zIndex: 1,
                            }}
                        />
                    </div>
                )}
                <CardBody>
                    <div className="d-flex justify-content-between align-items-start gap-2">
                        <CardTitle tag="h5" className="mb-2 text-truncate">{event.title}</CardTitle>
                        <small>{event.price}</small>
                    </div>
                    <div className="mb-0">
                        <small className="text-muted  fs-14">
                            {moment(event.event_date).format('MMM Do, YYYY')}
                        </small>
                    </div>
                    <div className="mb-0">
                        <small className="text-muted  fs-14">
                            {moment(event.start_time, ['h:mm A', 'HH:mm']).format('h:mm A')} - {moment(event.end_time, ['h:mm A', 'HH:mm']).format('h:mm A')}
                        </small>
                    </div>
                    <div className="mb-0">
                        <small className="text-muted  fs-14">
                            {event.location?.location}, {event.location?.country} ({event.mode})
                        </small>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                    </div>
                    <p className="mt-3 mb-3 text-muted small elipsis line-3 fs-14">
                        {event.description}
                    </p>

                    <div className="d-flex justify-content-between align-items-center">
                        <button
                            className="btn btn-sm btn-outline-info"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleViewTickets(event);
                            }}
                        >
                            <i className="bx bx-ticket"></i> View Tickets
                        </button>
                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => {
                                    setModal(true);
                                    setEditingEvent(null);
                                    setCurrentStep(1);
                                    onEdit(event);// 👈 always reset to 1!
                                }}
                            >
                                Edit
                            </button>
                            <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete(event.id);
                                }}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );

    const renderEmptyState = (message) => (
        <Card className="text-center py-4">
            <CardBody>
                <i className="bx bx-calendar-event display-4 text-muted mb-3"></i>
                <h5 className="text-muted">{message}</h5>
            </CardBody>
        </Card>
    );

    const fetchCategories = () => {
        axios.get('/api/event-categories')
            .then(response => {
                setCategories(response.data.data || []);
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'Failed to fetch Session categories',
                });
            });
    };

    const handleAddCategory = () => {
        if (!newCategory.name.trim()) {
            toast.error('Category name is required');
            return;
        }

        setIsAddingCategory(true);
        axios.post('/api/event-categories', {
            name: newCategory.name,
            description: newCategory.description
        })
            .then(response => {
                toast.success('Category added successfully');
                fetchCategories();
                setShowCategoryModal(false);
                setNewCategory({ name: '', description: '' });
            })
            .catch(error => {
                console.error('Error adding category:', error);
                toast.error(error.response?.data?.message || 'Failed to add category');
            })
            .finally(() => {
                setIsAddingCategory(false);
            });
    };

    const allEvents = [...pastEvents, ...todaysEvents, ...upcomingEvents].sort((a, b) => {
        return new Date(b.event_date) - new Date(a.event_date);
    });

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center">
                                <CardTitle className="h4">Sessions Management Dashboard</CardTitle>
                                <button className="btn btn-primary btn-sm" onClick={() => createEvent()}>
                                    <i className="bx bx-plus me-1"></i> Add New Session
                                </button>
                            </div>
                            <p className="card-title-desc">
                                Manage and view Sessions with Session images, names, Session dates, and Session descriptions.
                            </p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* upcomingEvents.map(renderEventCard) */}
            {/* todaysEvents.map(renderEventCard) */}
            {/* pastEvents.map(renderEventCard) */}

            {loading ? (
                <Row>
                    <Col className="text-center my-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </Col>
                </Row>
            ) : (
                <Row className="mt-4">
                    <Col>
                        <Card className="">
                            <CardBody>
                                <div className="d-flex justify-content-between gap-2 align-items-center mb-5">
                                    <div className="avatar-xs me-3">
                                        <span className="avatar-title rounded-circle bg-success bg-opacity-10 text-success font-size-18">
                                            <i className="bx bx-calendar-plus"></i>
                                        </span>
                                    </div>
                                    <div className="search-div">
                                        <Input
                                            type="select"
                                            value={eventFilter}
                                            onChange={(e) => setEventFilter(e.target.value)}
                                            style={{ maxWidth: '300px', minWidth: '300px', height: 'fit-content' }}
                                        >
                                            <option value="allEvents">All Sessions</option>
                                            <option value="upcomingEvents">Upcoming Session</option>
                                            <option value="todaysEvents">Today Sessions</option>
                                            <option value="pastEvents">Past Sessions</option>
                                        </Input>
                                    </div>
                                </div>
                                <Row className='g-3'>
                                    {eventFilter == 'allEvents' ? allEvents.map(renderEventCard) :
                                        eventFilter == 'upcomingEvents' ? upcomingEvents.map(renderEventCard) :
                                            eventFilter == 'todaysEvents' ? todaysEvents.map(renderEventCard) :
                                                eventFilter == 'pastEvents' && pastEvents.map(renderEventCard)}
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            )}

            {/* Add Event Modal */}
            <Modal isOpen={modal} centered toggle={() => setModal(false)} size="lg" backdrop={false}>
                <ModalHeader toggle={() => {
                    setModal(false);
                    setEditingEvent(null);
                    setCurrentStep(1)
                }}>
                    {editingEvent ? 'Edit Session' : 'Create New Session'}
                </ModalHeader>
                <Form
                    onSubmit={(e) => {
                        e.preventDefault();
                        console.log("Form onSubmit fired. Current step:", currentStep);
                        if (currentStep === 4) {
                            handleSubmit(e);
                        }
                    }}
                >

                    <ModalBody>
                        {/* Step Navigation */}
                        <div className="d-flex justify-content-between align-items-center mt-2 position-relative" style={{ height: '80px', width: '100%', margin: '0 auto' }}>
                            {[
                                { number: 1, title: 'Basic Info' },
                                { number: 2, title: 'Date & Time' },
                                { number: 3, title: 'Session Details' },
                                { number: 4, title: 'Location & Pricing' },
                            ].map((item, index, arr) => (
                                <div
                                    key={index}
                                    className="text-center position-relative flex-fill"
                                    style={index === arr.length - 1 ? { width: '18%' } : {}}
                                >
                                    {/* Line to next step */}
                                    {index !== arr.length - 1 && (
                                        <div
                                            className={`position-absolute border-top ${currentStep > item.number ? 'border-success' : 'border-secondary'}`}
                                            style={{
                                                top: '20px',
                                                left: '50%',
                                                width: '100%',
                                                height: '2px',
                                                zIndex: 0,
                                            }}
                                        ></div>
                                    )}

                                    {/* Circle */}
                                    <div
                                        className={`rounded-circle d-flex align-items-center justify-content-center 
                        ${currentStep === item.number
                                                ? 'bg-primary text-white fw-bold'
                                                : currentStep > item.number
                                                    ? 'bg-success text-white'
                                                    : 'bg-light text-muted'}`}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            zIndex: 1,
                                            margin: '0 auto',
                                            position: 'relative',
                                        }}
                                    >
                                        {currentStep > item.number ? '✓' : item.number}
                                    </div>

                                    {/* Title */}
                                    <div className={currentStep === item.number ? 'fw-bold text-primary mt-1' : 'text-muted mt-1'}>
                                        {item.title}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {renderStepForm()}
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-between">
                        <div>
                            {currentStep > 1 ? (
                                <Button color="secondary" onClick={prevStep} className="me-2">
                                    <FaArrowLeft className="me-2" /> Previous
                                </Button>
                            ) : (
                                <div></div>
                            )}
                        </div>

                        <div>
                            {currentStep < 4 ? (
                                <Button color="primary" onClick={nextStep} type="button" id="nextStepButton">
                                    <FaArrowRight className="me-2" /> Next
                                </Button>
                            ) : (
                                <Button
                                    color="success"
                                    type="submit"
                                    id="submitSessionButton"
                                >
                                    {editingEvent
                                        ? loading ? 'Updating...' : 'Update Session'
                                        : loading ? 'Creating...' : 'Create Session'}
                                </Button>
                            )}

                        </div>
                    </ModalFooter>

                </Form>
            </Modal>

            {/* Add Category Modal */}
            <Modal isOpen={showCategoryModal} toggle={() => setShowCategoryModal(false)} centered backdrop={false}>
                <ModalHeader toggle={() => setShowCategoryModal(false)}>Add New Category</ModalHeader>
                <ModalBody>
                    <FormGroup className="mb-3">
                        <Label>Category Name <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            placeholder="Enter category name"
                            value={newCategory.name}
                            onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                            disabled={isAddingCategory}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>Description</Label>
                        <Input
                            type="textarea"
                            placeholder="Enter category description (optional)"
                            rows="3"
                            value={newCategory.description}
                            onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
                            disabled={isAddingCategory}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="light"
                        onClick={() => setShowCategoryModal(false)}
                        disabled={isAddingCategory}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleAddCategory}
                        disabled={isAddingCategory}
                    >
                        {isAddingCategory ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                Adding...
                            </>
                        ) : 'Add Category'}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* New Organizer Modal */}
            <Modal isOpen={showNewOrganizerModal} centered backdrop={false} toggle={() => !isCreatingOrganizer && setShowNewOrganizerModal(false)} backdrop={false}>
                <ModalHeader toggle={() => !isCreatingOrganizer && setShowNewOrganizerModal(false)}>
                    Add New Organizer
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label>Name *</Label>
                            <Input
                                type="text"
                                value={newOrganizer.name}
                                onChange={(e) => setNewOrganizer(prev => ({ ...prev, name: e.target.value }))}
                                placeholder="Enter organizer name"
                                disabled={isCreatingOrganizer}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Email *</Label>
                            <Input
                                type="email"
                                value={newOrganizer.email}
                                onChange={(e) => setNewOrganizer(prev => ({ ...prev, email: e.target.value }))}
                                placeholder="Enter email address"
                                disabled={isCreatingOrganizer}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Password *</Label>
                            <Input
                                type="password"
                                value={newOrganizer.password}
                                onChange={(e) => setNewOrganizer(prev => ({ ...prev, password: e.target.value }))}
                                placeholder="Enter password"
                                disabled={isCreatingOrganizer}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Confirm Password *</Label>
                            <Input
                                type="password"
                                value={newOrganizer.confirmPassword}
                                onChange={(e) => setNewOrganizer(prev => ({ ...prev, confirmPassword: e.target.value }))}
                                placeholder="Confirm password"
                                disabled={isCreatingOrganizer}
                            />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="secondary"
                        onClick={() => setShowNewOrganizerModal(false)}
                        disabled={isCreatingOrganizer}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleCreateOrganizer}
                        disabled={isCreatingOrganizer || !newOrganizer.name || !newOrganizer.email || !newOrganizer.password || newOrganizer.password !== newOrganizer.confirmPassword}
                    >
                        {isCreatingOrganizer ? 'Creating...' : 'Create Organizer'}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Tickets Modal */}
            <Modal isOpen={ticketModal} centered toggle={() => setTicketModal(false)} size="lg" backdrop={false}>
                <ModalHeader toggle={() => setTicketModal(false)}>
                    {selectedEvent?.title} - Tickets ({tickets.length})
                </ModalHeader>
                <ModalBody>
                    {ticketLoading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            <p className="mt-2">Loading tickets...</p>
                        </div>
                    ) : tickets.length > 0 ? (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Ticket #</th>
                                        <th>Status</th>
                                        <th>Purchased</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tickets.map((ticket) => (
                                        <tr key={ticket.id}>
                                            <td>{ticket.ticket_number}</td>
                                            <td>
                                                <span className={`badge bg-${ticket.status === 'confirmed' ? 'success' : 'warning'}`}>
                                                    {ticket.status}
                                                </span>
                                            </td>
                                            <td>{moment(ticket.created_at).format('MMM D, YYYY h:mm A')}</td>
                                            <td>
                                                {ticket.qr_code_url && (
                                                    <a
                                                        href={ticket.qr_code_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-sm btn-outline-primary me-1"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        View QR Code
                                                    </a>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <i className="bx bx-info-circle text-muted" style={{ fontSize: '48px' }}></i>
                            <h5 className="mt-3">No tickets found</h5>
                            <p className="text-muted">There are no tickets purchased for this Session yet.</p>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="secondary"
                        onClick={() => setTicketModal(false)}
                    >
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
};

export default connect(null, { setBreadcrumbItems })(EventsManagement);